<!-- X192.vue -->
<template>
  <div class="course-card" @click="handleClick">
    <div class="card-wrapper">
      <!-- Обложка -->
      <div class="cover-container">
        <img
          v-if="coverImage"
          class="cover-image"
          :src="coverImage"
          :alt="title"
          loading="lazy"
        />
        <div v-else class="cover-placeholder">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
            <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" fill="currentColor"/>
          </svg>
        </div>
      </div>

      <!-- Заголовок -->
      <h3 class="course-title">{{ title }}</h3>

      <!-- Прогресс -->
      <div class="progress-section">
        <div class="progress-info">
          <span class="progress-percent">{{ clampedProgress }}%</span>
          <span v-if="lessonLabel" class="lesson-info">{{ lessonLabel }}</span>
        </div>
        
        <div class="progress-bar">
          <div 
            class="progress-fill"
            :style="{ width: clampedProgress + '%' }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "X192",
  
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    coverImage: {
      type: String,
      default: ''
    },
    progressPercent: {
      type: Number,
      default: 0
    },
    currentLesson: {
      type: Number,
      default: 0
    },
    totalLessons: {
      type: Number,
      default: 0
    }
  },
  
  computed: {
    clampedProgress() {
      return Math.round(Math.max(0, Math.min(100, this.progressPercent)));
    },
    
    lessonLabel() {
      if (this.totalLessons > 0) {
        const current = Math.max(0, this.currentLesson);
        return `${current}/${this.totalLessons}`;
      }
      return '';
    }
  },
  
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>

<style scoped>
.course-card {
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  flex-shrink: 0;
  background: #ffffff;
  border-radius: 16px; /* Уменьшено с 20px */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06); /* Мягче тень */
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
}

.course-card:hover {
  transform: translateY(-3px); /* Уменьшено с -4px */
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}

.card-wrapper {
  padding: 14px; /* Уменьшено с 20px */
  display: flex;
  flex-direction: column;
  gap: 10px; /* Уменьшено с 14px */
  height: 100%;
}

/* Обложка */
.cover-container {
  width: 100%;
  aspect-ratio: 16 / 9; /* Было 16/10, теперь более широкая */
  border-radius: 10px; /* Уменьшено с 12px */
  overflow: hidden;
  background: #f1f5f9;
}

.cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.course-card:hover .cover-image {
  transform: scale(1.05);
}

.cover-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cbd5e1;
}

/* Заголовок */
.course-title {
  font-family: 'Poppins', sans-serif;
  font-size: 15px; /* Уменьшено с 17px */
  font-weight: 600;
  line-height: 1.3; /* Уменьшено с 1.4 */
  color: #1e293b;
  margin: 0;
  min-height: 40px; /* Уменьшено с 48px */
  
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Прогресс */
.progress-section {
  display: flex;
  flex-direction: column;
  gap: 8px; /* Уменьшено с 10px */
  margin-top: auto;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
}

.progress-percent {
  color: #0095ec;
  font-size: 13px; /* Уменьшено с 14px */
}

.lesson-info {
  color: #64748b;
  font-size: 12px; /* Уменьшено с 13px */
}

.progress-bar {
  width: 100%;
  height: 6px; /* Уменьшено с 8px */
  background: #e2e8f0;
  border-radius: 3px; /* Уменьшено с 4px */
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #0095ec 0%, #0ea5e9 100%);
  border-radius: 3px;
  transition: width 0.5s ease;
}

/* Адаптивность */
@media (max-width: 1200px) {
  .card-wrapper {
    padding: 12px;
  }
  
  .course-title {
    font-size: 14px;
    min-height: 38px;
  }
}

@media (max-width: 768px) {
  .card-wrapper {
    padding: 12px;
    gap: 8px;
  }
  
  .course-title {
    font-size: 14px;
    min-height: 36px;
  }
  
  .progress-info {
    font-size: 11px;
  }
  
  .progress-percent {
    font-size: 12px;
  }
  
  .lesson-info {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .card-wrapper {
    padding: 10px;
  }
  
  .course-title {
    font-size: 13px;
  }
}
</style>